"use client"

import Link from "next/link"

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { SITE_NAV, SITE_SERVICES } from "@/lib/site-nav"

/** Пункты главного меню портала — шапка (mobile) и бургер редактора `/labels`. */
export function PortalNavMenuItems() {
  return (
    <>
      <DropdownMenuItem render={<Link href={SITE_NAV.home.href} prefetch={false} />}>
        {SITE_NAV.home.label}
      </DropdownMenuItem>
      <DropdownMenuItem render={<a href={SITE_NAV.labels.href} />}>
        {SITE_NAV.labels.label}
      </DropdownMenuItem>
      <DropdownMenuItem render={<a href={SITE_NAV.km.href} />}>
        {SITE_NAV.km.label}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      {SITE_SERVICES.map((item) => (
        <DropdownMenuItem
          key={item.href}
          render={<Link href={item.href} prefetch={false} />}
        >
          {item.label}
        </DropdownMenuItem>
      ))}
      <DropdownMenuSeparator />
      <DropdownMenuItem render={<Link href={SITE_NAV.support.href} prefetch={false} />}>
        {SITE_NAV.support.label}
      </DropdownMenuItem>
    </>
  )
}
